<template>
  <div>
    <!-- <div class="left content-left">
      <AreaTree ref="areaTree" :moduleName="moduleName" v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div> -->
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for="a_name">设备编号</label>
            <input
              v-model.trim="search.deviceSn"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
           <div class="form-group">
            <label>告警内容</label>
            <input
              v-model.trim="search.content"
              class="form-control"
              type="text"
              placeholder
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-primary"
                id="search_btn"
                @click="searchList"
              >
                查询
              </button>
            </span>
            <span class="search_btn">
              <button
                type="button"
                class="btn btn-primary"
                id="search_btn"
                @click="downloadData"
              >
                导出
              </button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <!-- <span class='add_btn'><button  type="button" class="btn btn-default" id="addarea" >添加</button></span> -->
            <!-- <span class="download_btn"><ExportExcel v-bind:tableListData="this.tableListData" v-bind:tableListDataAll="this.tableListDataAll" v-bind:downloadFileds="this.downloadFileds"></ExportExcel></span> -->
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>

      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="停车道路"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="报警时间"
            prop="lastUpTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备类型"
            prop="type"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备编号"
            prop="devSn"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="泊位号"
            prop="spaceNum"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="报警内容"
            prop="content"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="剩余电量/电压"
            prop="pow"
          >
            <!-- <template slot-scope="scope">
              <div class="electricity">
                <div class="battery">
                  <canvas
                    width="20"
                    height="10"
                    :id="scope.row.devSn"
                    class="show_pow"
                  ></canvas>
                  <canvas
                    width="5"
                    height="5"
                    :id="scope.row.devSn + 's'"
                    class="pow_head"
                  ></canvas>
                </div>
                <div>{{ !scope.row.pow ? "" : scope.row.pow }}</div>
              </div>
            </template> -->
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip
						label="是否处理"
					>
					<template slot-scope='scope'>
						{{scope.row.isHandle=='n'?'未处理':'已处理'}}
					</template>
          </el-table-column>-->
          <!-- <el-table-column  show-overflow-tooltip
						label="处理时间"
						prop="uptTime"
					>
          </el-table-column>-->
          <!-- <el-table-column  show-overflow-tooltip
						label="操作"
						width='200px'
					>
						<template  slot-scope="scope">
							<button class="edit"  type="button" >修改</button>
							<button class="delete"   type="button">删除</button>
						</template>
          </el-table-column>-->
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import { equipWarn } from "@/api/url";

import Page from "../../commons/page.vue";

import AreaTree from "../../commons/areaTree.vue";

import Refresh from "../../commons/refresh.vue";

import SearchParking from "@/page/commons/searchParking";

export default {
  data() {
    return {
      moduleName: "",

      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        deviceSn: "",
        content:""
        // stationSn:""
      },
      tableListData: [],
      treeData: {
        deviceType: "",
      },
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      var _this = this;
      _this.tableListDataTitle = [];
      _this.tableListData = [];
      this.$get(equipWarn(), {
        limit: this.search.pageSize,
        page: curPage,
        devSn: this.search.deviceSn,
        content:this.search.content,
        parkingId: this.parking?.parkingId ?? null,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = rows.map((item) => {
          if (
            item.parkingId &&
            typeof JSON.parse(item.parkingId) === "object"
          ) {
            item.parkingName = JSON.parse(item.parkingId).parkingName;
          }
          return item;
        });
        // _this.$nextTick(this.canvasPow);
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },
    downloadData() {
      const { deviceSn } = this.search;
      this.$downloadFileRequest(
        "/api/parking/nbOnerankdev/alarmExport",
        {
          parkingId: this.parking?.parkingId ?? null,
          deviceSn: deviceSn ? deviceSn : null,
        },
        "报警管理"
      );
    },
    // canvasPow() {
    //   var _this = this;
    //   for (let item of _this.tableListData) {
    //     console.log(item.type);

    //     var canvas = document.getElementById(item.devSn);
    //     canvas.style = "border:1px solid #696969";
    //     var context = canvas.getContext("2d");
    //     context.clearRect(0, 0, 20, 10);
    //     if (item.type == "nb地磁") {
    //       if (item.pow > 0) {
    //         context.fillStyle = "green";
    //         context.fillRect(0, 0, 20, 10);
    //       }
    //     } else {
    //       if (item.pow >= 80) {
    //         context.fillStyle = "green";
    //       } else if (item.pow >= 40 && item.pow < 80) {
    //         context.fillStyle = "#FF6100";
    //       } else if (item.pow < 40) {
    //         context.fillStyle = "red";
    //       }
    //       context.fillRect(0, 0, (20 / 100) * item.pow, 10);
    //     }

    //     var canvas1 = document.getElementById(item.devSn + "s");
    //     var context1 = canvas1.getContext("2d");
    //     context1.fillStyle = "#696969";
    //     context1.fillRect(0, 0, 5, 5);
    //   }
    // },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
  },
  components: {
    Page,
    AreaTree,
    Refresh,
    SearchParking,
  },
  created: function () {},
  mounted: function () {
    this.tableList(this.search.pageNumber);
  },

  watch: {},
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}

.list-right {
  padding-bottom: 100px !important; /* 为分页组件留出空间 */
  box-sizing: border-box;
}

.pagbox {
  position: absolute;
  bottom: 10px;
  right: 20px;
  background: white;
  padding: 10px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
/* .edit,
.delete,
.chargingRules {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
} */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>